// 2025 Federal EITC Parameters
// Source: IRS Earned Income Tax Credit Parameters, 1975-2025
export const federalEITCTable = {
  no_children: {
    all_others: {
      phaseInRate: 0.0765,
      maxIncome: 8490,
      flatAmount: 649,
      phaseOutRate: 0.0765,
      phaseOutStart: 10620,
      phaseOutEnd: 19104,
    },
    married: {
      phaseInRate: 0.0765,
      maxIncome: 8490,
      flatAmount: 649,
      phaseOutRate: 0.0765,
      phaseOutStart: 17730,
      phaseOutEnd: 26214,
    },
  },
  one_child: {
    all_others: {
      phaseInRate: 0.34,
      maxIncome: 12730,
      flatAmount: 4328,
      phaseOutRate: 0.1598,
      phaseOutStart: 23350,
      phaseOutEnd: 50434,
    },
    married: {
      phaseInRate: 0.34,
      maxIncome: 12730,
      flatAmount: 4328,
      phaseOutRate: 0.1598,
      phaseOutStart: 30470,
      phaseOutEnd: 57554,
    },
  },
  two_children: {
    all_others: {
      phaseInRate: 0.4,
      maxIncome: 17880,
      flatAmount: 7152,
      phaseOutRate: 0.2106,
      phaseOutStart: 23350,
      phaseOutEnd: 57310,
    },
    married: {
      phaseInRate: 0.4,
      maxIncome: 17880,
      flatAmount: 7152,
      phaseOutRate: 0.2106,
      phaseOutStart: 30470,
      phaseOutEnd: 64430,
    },
  },
  three_children: {
    all_others: {
      phaseInRate: 0.45,
      maxIncome: 17880,
      flatAmount: 8046,
      phaseOutRate: 0.2106,
      phaseOutStart: 23350,
      phaseOutEnd: 61555,
    },
    married: {
      phaseInRate: 0.45,
      maxIncome: 17880,
      flatAmount: 8046,
      phaseOutRate: 0.2106,
      phaseOutStart: 30470,
      phaseOutEnd: 68675,
    },
  },
}
